export default __webpack_public_path__ + "static/media/gallery-wip-handle_12.94460a0d.jpg";